import React from 'react';
import TemplateTextField from './TemplateTextField';

const StepScope = ({ formData, updateFormData, nextStep, prevStep, disabled }) => {
  const data = formData.scope;

  const handleChange = (field, value) => {
    updateFormData('scope', { [field]: value });
  };

  return (
    <fieldset disabled={disabled}>
      <h4 className="soa-step-title">Scope of Advice</h4>
      <p className="soa-step-subtitle">Define what this Statement of Advice covers and any limitations</p>

      <TemplateTextField
        fieldKey="scope.adviceCovered"
        label="What is covered in this advice? *"
        value={data.adviceCovered}
        onChange={(val) => handleChange('adviceCovered', val)}
        placeholder="e.g. This advice covers your investment strategy, superannuation, and retirement planning needs..."
        rows={4}
        disabled={disabled}
        hint="Describe the topics and areas this SOA addresses"
      />

      <TemplateTextField
        fieldKey="scope.adviceExcluded"
        label="What is not covered?"
        value={data.adviceExcluded}
        onChange={(val) => handleChange('adviceExcluded', val)}
        placeholder="e.g. This advice does not cover estate planning, insurance needs analysis, or Centrelink entitlements..."
        rows={3}
        disabled={disabled}
        hint="Explicitly state what is outside the scope of this advice"
      />

      <div className="soa-form-group">
        <label>Limitations</label>
        <textarea
          className="form-control"
          value={data.limitations}
          onChange={(e) => handleChange('limitations', e.target.value)}
          placeholder="e.g. This advice is based on the information provided at the date of preparation. Changes in legislation or personal circumstances may affect the suitability of this advice..."
          rows={3}
        />
      </div>

      <div className="soa-step-nav">
        <button className="btn btn-outline-secondary" onClick={prevStep}>
          <i className="bi bi-arrow-left me-1"></i>Back
        </button>
        <button className="btn btn-primary" onClick={nextStep}>
          Next: Current Situation <i className="bi bi-arrow-right ms-1"></i>
        </button>
      </div>
    </fieldset>
  );
};

export default StepScope;
